
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Radio',
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    value: {
      type: [String, Number],
      required: true,
    },
    vertical: {
      type: Boolean,
      default: false,
    },
    rtl: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const onLabelClick = () => {
      emit('update:modelValue', props.value);
    };

    return { onLabelClick };
  },
});
